import type { LegalDocument } from '../types/legal';

export const AGE_SUITABILITY_CONTENT: LegalDocument = {
  title: 'Age Suitability',
  effectiveDate: 'August 2026',
  preamble: [
    `<strong>Effective Date:</strong> August 2026`,
    `Hello Gwiji ("Company," "we," "us," or "our") provides a capital partnerships platform for investors, entrepreneurs, and business partners. This Age Suitability statement explains who may use the Platform and how we handle age-related requirements.`,
    `This page should be read together with our Terms and Conditions and Privacy Policy.`,
  ],
  sections: [
    {
      title: '1. Minimum Age',
      blocks: [
        {
          type: 'p',
          html: `<strong>1.1 General requirement.</strong> The Hello Gwiji Platform is intended for individuals who are at least <strong>18 years of age</strong> (or the age of legal majority in their jurisdiction, whichever is higher).`,
        },
        {
          type: 'p',
          html: `<strong>1.2 No use by minors.</strong> We do not knowingly offer services to, or collect personal information from, anyone under the minimum age. If you are under 18, you must not register for, access, or use the Platform.`,
        },
      ],
    },
    {
      title: '2. Eligibility to Use the Platform',
      blocks: [
        {
          type: 'ul',
          items: [
            `You must be legally able to enter into binding contracts in your jurisdiction.`,
            `You must have the legal capacity to participate in investment, fundraising, or partnership activities where applicable.`,
            `You must complete any identity, age, or eligibility verification we require before accessing regulated features.`,
            `Business accounts must be registered and operated by an authorized adult representative with legal authority to act on behalf of the entity.`,
          ],
        },
      ],
    },
    {
      title: '3. Verification',
      blocks: [
        {
          type: 'p',
          html: `We may request proof of age, identity, or authorization as part of onboarding, compliance checks, or ongoing monitoring. Failure to provide satisfactory verification may result in restricted access, suspension, or account closure.`,
        },
      ],
    },
    {
      title: '4. Parental and Guardian Responsibility',
      blocks: [
        {
          type: 'p',
          html: `If you are a parent or guardian and believe a minor has provided us with personal information or created an account, please contact us promptly at <a href="mailto:support@hellogwiji.com">support@hellogwiji.com</a>. We will take reasonable steps to investigate and remove the information or close the account where appropriate.`,
        },
      ],
    },
    {
      title: '5. Content and Communications',
      blocks: [
        {
          type: 'p',
          html: `Marketing materials, website content, and platform communications are directed at adult users interested in capital partnerships, investing, and entrepreneurship. They are not designed for children or general youth audiences.`,
        },
      ],
    },
    {
      title: '6. Changes to This Statement',
      blocks: [
        {
          type: 'p',
          html: `We may update this Age Suitability statement from time to time. Material changes will be posted on this page with an updated effective date. Continued use of the Platform after changes take effect constitutes acceptance of the revised statement, subject to applicable law.`,
        },
      ],
    },
    {
      title: '7. Contact',
      blocks: [
        {
          type: 'p',
          html: `<strong>Hello Gwiji Support</strong><br><strong>Email:</strong> support@hellogwiji.com<br><strong>Location:</strong> Nairobi, Kenya`,
        },
      ],
    },
  ],
};
